<template>
  <div class="df-container df-loading" v-if="value">
    <div class="mask"></div>
    <div class="loading">
      <img src="./images/loading.gif">
      <div class="text">{{info.content}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'loading',
    data: function () {
      return {}
    },
    props: [
      'value',
      'info',
    ],
    created() {

    },
    mounted() {

    },
    watch: {},
    methods: {},
  }
</script>
<style lang="scss" scoped type="text/scss">
  @import "css/common";
  .mask{
    opacity: 0;
  }
  .df-loading {
    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 40px 50px;
      background-color: #333;
      opacity: 0.7;
      color: #fff;
      border-radius: 10px;
      img {
        width: 80px;
        height: 80px;
      }
      .text {
        margin-top: 10px;
        font-size: 28px;
      }
    }
  }
</style>
